import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { ApplianceDetailsStore, ApplianceDetailsState } from './appliance-details.store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IdName } from '@shared/models/id-name';
import { TranslateService } from '@ngx-translate/core';
import { APPLIANCE_TYPES } from '../models/appliance-type.constants';

@Injectable({ providedIn: 'root' })
export class ApplianceDetailsQuery extends Query<ApplianceDetailsState> {
	/** Emits when translations are ready (and again on language change). */
	applianceTypes$: Observable<IdName<number>[]> = this.translateService.stream('ApplianceDetails').pipe(
		map((translations: Record<string, string>) =>
			APPLIANCE_TYPES.map(type => ({
				...type,
				Name: translations[`${type.Name}Type`] ?? type.Name
			}))
		)
	);

	constructor(
		protected store: ApplianceDetailsStore,
		private readonly translateService: TranslateService
	) {
		super(store);
	}
}
